import React, { useContext, useState } from 'react';
import {
    Box,
    Button,
    MenuItem,
    TextField,
    Grid,
    Autocomplete,
    Chip,
    Checkbox,
    ListItemText,
} from '@mui/material';
import '../../assets/styles/FilterBar.scss';
import { SubCategoryContext } from '../../context/SubCategoryContext';
import { CommonContext } from '../../context/CommonContext';
import { status } from '../../utils/config';
import CommonDateRangePicker from '../common/CommonDateRangePicker';

export default function FilterBar() {
    const { filters, setFilters, initialFilters, onLoadApi } = useContext(SubCategoryContext);
    const { merchant, user } = useContext(CommonContext);
    const [showAllMerchants, setShowAllMerchants] = useState(false);

    const handleChange = (key, value) => {
        setFilters(prev => ({ ...prev, [key]: value }));
    };

    const handleDateRangeChange = ({ startDate, endDate }) => {
        setFilters(prev => ({
            ...prev,
            dateRange: { startDate, endDate }
        }));
    };

    const handleSubmit = () => {
        onLoadApi();
    };

    const handleReset = () => {
        setFilters(initialFilters);
        onLoadApi(initialFilters);
        setShowAllMerchants(false);
    };

    return (
        <Box className="shipment-filter-bar">
            <Grid container spacing={2}>
                <Grid item size={{ xs: 6, md: 4 }}>
                    <div className="search-box">
                        <TextField
                            select
                            name="searchBy"
                            value={filters.searchBy}
                            onChange={(e) => handleChange('searchBy', e.target.value)}
                            size="small"
                            className="search-select"
                            SelectProps={{
                                displayEmpty: true,
                            }}
                        >
                            <MenuItem value="name">Sub Category Name</MenuItem>
                            <MenuItem value="id">Sub Category ID</MenuItem>
                        </TextField>

                        <TextField
                            size="small"
                            placeholder={`Enter ${filters.searchBy === 'name' ? 'Sub Category Name' : 'Sub Category ID'} here`}
                            value={filters.searchValue}
                            onChange={(e) => handleChange('searchValue', e.target.value)}
                            className="search-input"
                        />
                    </div>

                </Grid>

                {user?.user_type !== 'Merchant' && (
                    <Grid item size={{ xs: 6, md: 4 }}>
                        <Autocomplete
                            multiple
                            options={merchant || []}
                            getOptionLabel={(option) => option.company_name}
                            value={merchant.filter(item => filters.merchant_id.includes(item.id))}
                            onChange={(e, newValue) => {
                                const selectedIds = newValue.map(item => item.id);
                                handleChange('merchant_id', selectedIds);
                            }}
                            disableCloseOnSelect
                            limitTags={1}
                            renderTags={(value, getTagProps) =>
                                value.map((option, index) => (
                                    <Chip
                                        key={option.id}
                                        label={option.company_name}
                                        {...getTagProps({ index })}
                                        size="small"
                                        sx={{ maxWidth: 100 }}
                                        onClick={() => setShowAllMerchants(true)}
                                    />
                                ))
                            }
                            renderOption={(props, option, { selected }) => (
                                <li {...props} key={option.id}>
                                    <Checkbox checked={selected} />
                                    <ListItemText primary={option.company_name} />
                                </li>
                            )}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Select Merchants"
                                    variant="outlined"
                                    size="small"
                                />
                            )}
                            onClick={() => setShowAllMerchants(true)}
                            sx={{
                                width: '100%',
                                '& .MuiInputBase-root': {
                                    height: showAllMerchants ? 'auto !important' : '30px',
                                    overflow: 'hidden',
                                    alignItems: 'flex-start',
                                    whiteSpace: 'normal',
                                },
                                '& .MuiChip-root': {
                                    maxWidth: '100px',
                                },
                            }}
                        />
                    </Grid>
                )}

                <Grid item size={{ xs: 6, md: 4 }}>
                    <TextField
                        select
                        label="Status"
                        name="status"
                        value={filters.status}
                        onChange={(e) => handleChange('status', e.target.value)}
                        fullWidth
                        size="small"
                    >
                        <MenuItem value="">Status</MenuItem>
                        {Object.entries(status).map(([key, value]) => (
                            <MenuItem value={key} key={key}>
                                {value}
                            </MenuItem>
                        ))}
                    </TextField>
                </Grid>

                <Grid item size={{ xs: 6, md: 4 }}>

                    <Box className="date-picker-wrapper">
                        <CommonDateRangePicker
                            startDate={filters?.dateRange?.startDate}
                            endDate={filters?.dateRange?.endDate}
                            onChange={handleDateRangeChange}
                        />
                    </Box>
                </Grid>

                <Grid item size={{ xs: 12, md: 12 }}>

                    <Box className="filter-actions">
                        <Box>
                            <Button className="search-btn" variant="contained" color="primary" size="medium" onClick={handleSubmit}>
                                Search
                            </Button>

                            <Button className="reset-btn ml-2" variant="outlined" color="primary" size="medium" onClick={handleReset}>
                                Reset
                            </Button>
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
}
